import { useCallback } from "react";
import {
  CME_OPTIONSET_GRADE,
  CMS_FEATURES_HYBRID,
  QA_SWIPER_NAV_MENU_TAB,
  UI_MOLECULE_SWIPER_SLIDES,
} from "../../_common/modules/Data/static";
import useGAViewScreen from "../../_common/modules/fe-modules/GA/useGAViewScreen";
import useGA from "../../_common/modules/fe-modules/GA/useGA";
import {
  GaEvent,
  GA_TOYOTA_FOR_YOU_FEATURES,
  GA_VEHICLE_FEATURES,
} from "../../_common/modules/fe-modules/GA/static";
import { stringSplitByHyphen } from "../../_common/helpers/utils";
import { useDataContext } from "../../_common/modules/Data/DataProvider";
import { useCmeContext } from "../../_common/modules/fe-cme/CMEProvider";
import { PAGE_FEATURES } from "../../_common/modules/fe-modules/Router/static";
import useCMSPageData from "../../_common/hooks/useCMSPageData";

export type UseFeaturesProps = {
  headerContent: any;
  mainContent: any;
  footerContent: any;
};

const useFeatures = (): UseFeaturesProps => {
  const { isHybridEngine } = useDataContext();
  const { cmeOptions } = useCmeContext();
  const { triggerGAEvent } = useGA();
  useGAViewScreen(GA_TOYOTA_FOR_YOU_FEATURES, GA_VEHICLE_FEATURES);

  const { data } = useCMSPageData({
    page: PAGE_FEATURES,
    queryKey: "featuresPage",
  });

  // ********************
  // Helpers
  // ********************
  const getSelectedGrade = useCallback(
    () => cmeOptions?.selectedOptions?.get(CME_OPTIONSET_GRADE),
    [cmeOptions?.selectedOptions],
  );

  const getSwiperSlidesItems = useCallback(
    (rawItems: any) =>
      rawItems
        .filter((item: any) => item.props.gradeId === getSelectedGrade())
        .filter((item: any) =>
          isHybridEngine ? item : item.props.id !== CMS_FEATURES_HYBRID,
        ),
    [getSelectedGrade, isHybridEngine],
  );

  // ********************
  // Data
  // ********************
  const getHeaderContent = useCallback(() => data?.containers?.header, [data]);

  const getMainContent = useCallback(
    () =>
      data?.containers?.main.map((component: any) => {
        if (component.type === UI_MOLECULE_SWIPER_SLIDES) {
          return {
            ...component,
            props: {
              ...component.props,
              onActiveIndexChangeParent: (index: number) => {
                triggerGAEvent(GaEvent.CONFIGURATOR_SELECT_TAB, {
                  tabName: stringSplitByHyphen(
                    getSwiperSlidesItems(component.props.items)[index].props.id,
                  ),
                });
              },
              items: getSwiperSlidesItems(component.props.items),
              qaId: QA_SWIPER_NAV_MENU_TAB,
            },
          };
        }
        return component;
      }),
    [data?.containers?.main, getSwiperSlidesItems, triggerGAEvent],
  );

  const getFooterContent = useCallback(() => data?.containers?.footer, [data]);

  return {
    headerContent: getHeaderContent(),
    mainContent: getMainContent(),
    footerContent: getFooterContent(),
  };
};

export default useFeatures;
